// tickets/vm-view
import { useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { useItemsStore } from 'src/hooks/use-items-store';
import { getTicketList, getTicketItem } from './data-view';
import { getTmsList, getTmsItem, getTmsNew } from './data-view';
import { getFuelList, getFuelItem, getFuelNew } from './data-view';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

// Ticket Api
class TicketApi {
  getItems(searchState) {
    return useItemsStore(searchState, getTicketList);
  }

  getDetail(payload, onSuccess) {    
    getTicketItem(payload).then((result) => {
      onSuccess(result);
    });
  }
}
export const ticketApi = new TicketApi();

// Tms Api
class TmsApi {
  getItems(searchState) {
    return useItemsStore(searchState, getTmsList);
  }

  getDetail(payload, onSuccess) {    
    getTmsItem(payload).then((result) => {
      onSuccess(result);
    });
  }

  getItemNew(onSuccess) {
    getTmsNew().then((result) => {
      onSuccess(result);
    });
  }
}
export const tmsApi = new TmsApi();

// Fuel Api
class FuelApi {
  getItems(searchState) {
    return useItemsStore(searchState, getFuelList);
  }

  getDetail(payload, onSuccess) {
    getFuelItem(payload).then((result) => {
      onSuccess(result);
    });
  }

  getItemNew(onSuccess) {
    getFuelNew().then((result) => {
      onSuccess(result);
    });
  }
}
export const fuelApi = new FuelApi();
